<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- <v-card>
            <v-card-text>
                <v-container>
                    <v-row justify="center" class="ml-12">
                        <v-col sm="3">
                            <v-btn class="mt-0" color="primary" rounded @click="add_new_installment" :loading="fetch_btn_load">+ Add Installment</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card> -->
        <v-card class="box">
            <v-data-table :headers="headers" :items="transport_installment_list" class="elevation-1 mytable" dense :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Transport Installment</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                          <v-btn class="mt-0" color="primary" rounded @click="add_new_installment" :loading="fetch_btn_load">+ Add Installment</v-btn>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details> </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" md="12" sm="12">
                                                    <v-combobox rounded v-model="ay" item-text="ay" :items="ay_selection_for_dashboard.component_list" label="Academic Year" persistent-hint outlined dense @change="getComponent()"></v-combobox>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.displayorder" persistent-hint label="Display Order" :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.name" persistent-hint label="Name" :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.percentage" persistent-hint type="number" label="Percentage" :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea v-model="editedItem.description" persistent-hint label="Description" :rules="[(v) => !!v || 'required']"></v-textarea>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <!-- from date -->
                                                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field dense v-model="new_from_date" @blur="date1 = parseDate(new_from_date)" v-on="on" prepend-icon="event" persistent-hint label="From Date"></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="date1" no-title @input="menu1 = false"></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <!-- to date -->
                                                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field dense v-model="new_to_date" @blur="date2 = parseDate(new_to_date)" v-on="on" prepend-icon="event" persistent-hint label="To Date"></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <!-- due date date -->
                                                    <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field dense v-model="new_due_date" @blur="date3 = parseDate(new_due_date)" v-on="on" prepend-icon="event" persistent-hint label="Due Date"></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="date3" no-title @input="menu3 = false"></v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                               
                                            <v-col cols="12" sm="12" md="12">
                                                <v-autocomplete color="#0F2027" dense rounded required v-model="editedItem.component_id" :items="component_list" item-text="name" item-value="id" label="Fee Component" outlined persistent-hint hint="Please Select Fee Component"></v-autocomplete>
                                            </v-col>
                                            </v-row>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'" @change="toggle(item)"></v-switch>
                </template>
            </v-data-table>
        </v-card>
        <!-- edit dialog  -->
        <v-dialog v-model="edit_dialog" max-width="700px">
            <v-card>
                <v-form v-model="valid">
                    <v-card-title class="toolbar">
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editedItem.displayorder" persistent-hint label="Display Order" :rules="[(v) => !!v || 'required']"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editedItem.name" persistent-hint label="Name" :rules="[(v) => !!v || 'required']"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editedItem.percentage" persistent-hint type="number" label="Percentage" :rules="[(v) => !!v || 'required']"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-textarea v-model="editedItem.description" persistent-hint label="Description" :rules="[(v) => !!v || 'required']"></v-textarea>
                                </v-col>
                                <v-row>
                                    <v-col cols="6" sm="6" md="6">
                                        <!-- from date -->
                                        <v-menu ref="menu11" v-model="menu11" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field dense v-model="new_from_date" @blur="date1 = parseDate(new_from_date)" v-on="on" prepend-icon="event" persistent-hint label="From Date"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date1" no-title @input="menu11 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="4" sm="4" md="4">
                                        <v-text-field v-model="editedItem.from_date" label="Current From Time" prepend-icon="mdi-clock-time-four-outline" v-bind="attrs" v-on="on" disabled></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" sm="6" md="6">
                                        <!-- to date -->
                                        <v-menu ref="menu22" v-model="menu22" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field dense v-model="new_to_date" @blur="date2 = parseDate(new_to_date)" v-on="on" prepend-icon="event" persistent-hint label="To Date"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date2" no-title @input="menu22 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="4" sm="4" md="4">
                                        <v-text-field v-model="editedItem.to_date" label="Current To Time" prepend-icon="mdi-clock-time-four-outline" v-bind="attrs" v-on="on" disabled></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6" sm="6" md="6">
                                        <!-- due date date -->
                                        <v-menu ref="menu33" v-model="menu33" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field dense v-model="new_due_date" @blur="date3 = parseDate(new_due_date)" v-on="on" prepend-icon="event" persistent-hint label="Due Date"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date3" no-title @input="menu33 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="4" sm="4" md="4">
                                        <v-text-field v-model="editedItem.due_date" label="Current Due Time" prepend-icon="mdi-clock-time-four-outline" v-bind="attrs" v-on="on" disabled></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                   <v-col cols="12" sm="12" md="12">
                                      <v-autocomplete color="#0F2027" dense rounded required v-model="editedItem.component" :items="component_list" item-text="name" label="Fee Component" outlined persistent-hint hint="Please Select Fee Component"></v-autocomplete>
                                  </v-col>
                                </v-row>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                        <v-btn class="mb-2 button" color="primary" @click="save_edited" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
            valid: false,
            ay_selection_for_dashboard: "",
            academic_year_list: null,
            ay: null,
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            headers: [
                {
                    text: "Display Order",
                    align: "left",
                    sortable: false,
                    value: "displayorder",
                },
                {
                    text: "Academic Year",
                    align: "left",
                    sortable: false,
                    value: "academicyear",
                },
                {
                    text: "Name",
                    align: "left",
                    sortable: false,
                    value: "name",
                },
                {
                    text: "Fee Component Name",
                    align: "left",
                    sortable: false,
                    value: "component",
                },
                {
                    text: "Percentage",
                    align: "left",
                    sortable: false,
                    value: "percentage",
                },
                {
                    text: "From Date",
                    align: "left",
                    sortable: false,
                    value: "from_date",
                },
                {
                    text: "To Date",
                    align: "left",
                    sortable: false,
                    value: "to_date",
                },
                {
                    text: "Due Date",
                    align: "left",
                    sortable: false,
                    value: "due_date",
                },
                {
                    text: "Status",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                id: "",
                isactive: true,
                name: "",
                percentage: "",
                displayorder: "",
                description: "",
                component:""
            },
            defaultItem: {
                id: "",
                isactive: true,
                name: "",
                academicyear: "",
                fromdate: "",
                todate: "",
                duedate: "",
                percentage: "",
                displayorder: "",
                description: "",
                ay: "",
                new_from_date: "",
                new_to_date: "",
                new_due_date: "",
                component:""
            },
            transport_installment_list: [],
            new_from_date: "",
            new_to_date: "",
            new_due_date: "",
            date1: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            date3: new Date().toISOString().substr(0, 10),
            menu1: false,
            menu2: false,
            menu3: false,
            menu11: false,
            menu22: false,
            menu33: false,
            fetch_btn_load: false,
            edit_dialog: false,
            attrs: "",
            on: "",
            component_list:[],
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Transport Installment" : "Edit Transport Installment";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        watch: {
            date1(val) {
                this.new_from_date = this.formatDate(this.date1);
            },
            date2(val) {
                this.new_to_date = this.formatDate(this.date2);
            },
            date3(val) {
                this.new_due_date = this.formatDate(this.date3);
            },
        },
        mounted() {
            this.onLoad();
        },
        methods: {
            getComponent(){
                this.component_list = []
                this.component_list = this.ay.all_component_list
                if(this.component_list == [] || this.component_list == ''){
                    this.showSnackbar("#b71c1c", "Fee component not added for this year...");
                }
            },
            add_new_installment() {
                this.dialog = true;
            },
            close() {
                this.dialog = false;
                this.edit_dialog = false;
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                this.editedIndex = this.transport_installment_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.edit_dialog = true;
            },
            close() {
                this.dialog = false;
                this.edit_dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/Transport/transportInstallmentHome")
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.msg == "200") {
                            this.overlay = false;
                            this.ay_selection_for_dashboard = res.data.ay_selection_for_dashboard;
                            this.ay = this.ay_selection_for_dashboard.current_academic_year;
                            this.transport_installment_list = res.data.transport_installment_list;
                            this.component_list = res.data.component_list
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            save() {
                const data = {
                    data: this.editedItem,
                    from_date: this.new_from_date,
                    to_date: this.new_to_date,
                    due_date: this.new_due_date,
                    ay: this.ay.ay,
                    component:this.component
                };
                axios
                    .post("/Transport/saveTransportInstallment", data)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Transport Installment Added Successfully..."); // show snackbar on success
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", "Transport Installment Already Present!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            },
            save_edited() {
                const data = {
                    data: this.editedItem,
                    from_date: this.new_from_date,
                    to_date: this.new_to_date,
                    due_date: this.new_due_date,
                    ay: this.ay.ay,
                };
                axios
                    .post("/Transport/editTransportInstallment", data)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Transport Installment Updated Successfully..."); // show snackbar on success
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            },
            toggle(item) {
                const data = {
                    id: item.id,
                    toggle: item.isactive,
                };
                this.overlay = true;
                axios
                    .post("/Transport/toggleTransportInstallment", data)
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Transport Insallment Status Changed!"); // show snackbar
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", "Something went wrong, Please try again later!"); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
